// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import {alertService} from "../../../services/AlertService";

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {getTanggalMerah, insertTanggalMerah, tanggalMerahSelector, updateTanggalMerah,} from "./tanggalMerahSlice";

import {Colors} from "../../../assets/Colors";

const MasterTanggalMerahPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const tanggalMerah = useSelector(tanggalMerahSelector);

    useEffect(() => {
        dispatch(
            getTanggalMerah({
                start: start,
                count: count,
                search: "",
            })
        );
    }, []);

    useEffect(() => {
        if (search !== "" && tanggalMerah.isGetSuccess && !tanggalMerah.isGetFetching) {
            let calc = tanggalMerah?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = tanggalMerah.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if (search === "" && tanggalMerah.isGetSuccess && !tanggalMerah.isGetFetching) {
            let calc = tanggalMerah?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = tanggalMerah.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (
            !tanggalMerah?.isGetFetching &&
            tanggalMerah.isGetSuccess &&
            maxPage === 0 &&
            firstLoading === false
        ) {
            let calc = tanggalMerah?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = tanggalMerah.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(
                getTanggalMerah({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (insertFetch) {
            setInsertFetch(false);
            if (tanggalMerah.isGetSuccess) {
                alertService.success(tanggalMerah.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    getTanggalMerah({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }

        if (updateFetch) {
            setUpdateFetch(false);
            if (tanggalMerah.isUpdateSuccess) {
                alertService.success(tanggalMerah.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    updateTanggalMerah({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }
    });

    // function handleGetTanggalMerah(params) {
    //   return dispatch(getTanggalMerah(params));
    // }

    function handleInsertTanggalMerah(param) {
        setInsertFetch(true);
        const params = {
            HolidaysName: param.inputOneValue,
            FromDate: param.startDate
        };

        dispatch(insertTanggalMerah(params));
    }

    function handleUpdateTanggalMerah(param) {
        setUpdateFetch(true);

        const params = {
            HolidaysName: param.inputOneValue,
            HolidaysID: currentData.HolidaysID,
            status: param.status,
            FromDate: param.startDate
        };
        dispatch(updateTanggalMerah(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        };
        dispatch(getTanggalMerah(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        };
        dispatch(getTanggalMerah(params));

        setPage(newPage);
        setStart(newStart);
    }

    function handleUpdateCount(newCount) {
        let calc = tanggalMerah.count - 1;
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: newCount === "-1" ? 0 : start,
            count: newCount === "-1" ? tanggalMerah.count : newCount,
            search: search,
        };
        dispatch(getTanggalMerah(params));

        setPage(1);
        setCount(newCount === "-1" ? tanggalMerah.count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>;
    } else {
        return (
            <div className="md:ml-64">
                <div
                    style={{background: Colors.primary}}
                    className="pt-14 pb-16 px-3 md:px-8 h-auto"
                >
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>
                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="TanggalMerah"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master TanggalMerah"
                                tableData={tanggalMerah.data}
                                colOneTitle="ID"
                                colOneData="HolidaysID"
                                colTwoTitle="Nama Tanggal Merah"
                                colTwoData="HolidaysName"
                                dateCol="Tanggal"
                                dateColData="FromDate"
                                status="Status"
                                fetching={tanggalMerah.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}
                            />
                        </div>
                    </div>
                </div>
                {showModalAdd && (
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Tanggal Merah"
                        inputOneTitle="Nama Tanggal Merah"
                        inputOneValue=""
                        StartDate={true}
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertTanggalMerah}
                    />
                )}
                {showModalEdit && (
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.HolidaysID}
                        modal={handleModal}
                        modalTitle="Ubah Tanggal Merah"
                        inputOneTitle="Nama Tanggal Merah"
                        inputOneValue={currentData.HolidaysName}
                        StartDate={true}
                        startDateValue={currentData.FromDate}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateTanggalMerah}
                    />
                )}
            </div>
        );
    }
};

export default MasterTanggalMerahPage;
